<template>
  <div class="content" v-if="cfg">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <div style="display: flex;">
              <div>
                <h3 class="mb-0">{{ this.entityType.toUpperCase() }}</h3>
                <p class="text-sm mb-0">
                  All {{ this.entityType }} from this organisation
                </p>
              </div>
              <div style="flex: 1.5;">
                <base-button size="sm" type="neutral" @click.native="handleNew()" style="float: right;">New</base-button>
              </div>
            </div>
          </template>
          <div>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
            </b-col>
            <el-table :data="queriedData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      @selection-change="selectionChange">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column width="120px"
                               label="Active"
                               prop="active"
                               sortable
                               align="center">
                <template v-slot="{row}">
                  <badge class="badge-dot mr-4">
                    <i :class="`bg-${row.active? 'success' : 'danger'}`"></i>
                  </badge>
                </template>
              </el-table-column>
              <el-table-column min-width="110px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-ruler-pencil"></i>
                  </base-button>
                  <base-button v-if="entityType === 'configurationgroups'"
                               @click.native="handleSettings($index, row)"
                               class="edit btn-link"
                               type="info"
                               size="sm"
                               icon
                  >
                    <i class="text-white ni ni-settings-gear-65"></i>
                  </base-button>
                  <base-button v-if="entityType === 'groups' || entityType === 'configurationgroups'"
                    @click.native="handleMembers($index, row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-settings"></i>
                  </base-button>

                  <base-button v-if="entityType === 'devices' || entityType === 'drivers'"
                               @click.native="handleLinks($index, row)"
                               class="edit btn-link"
                               type="info"
                               size="sm"
                               icon
                  >
                    <i class="text-white ni ni-lock-circle-open"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni ni-fat-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from './clientPaginationMixin'
import swal from 'sweetalert2';
import crudApi from "../../crud/crud-api";
import crudConfig from "../../crud/crud-config";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    props: ['config'],
  },
  beforeRouteEnter (to, from, next) {
    console.log('before route enter !!!!!!!!!')

    // TODO : Reset pagination and filter

    next(vm => {
/*
      if (clientPaginationMixin.pagination) {
        clientPaginationMixin.pagination.currentPage = 1
      }
*/
    })
  },
  data: _ => ({
      propsToSearch: ['name', 'registrationNumber', 'type', 'energyType'],
      tableColumns: [],
      tableData: [],
      selectedRows: [],
      entityType: {}
  }),
  computed: {
    cfg() {
      this.tableColumns = crudConfig[this.$route.name].table.tableColumns
      this.entityType = this.$route.name
      let cfg = crudConfig[this.$route.name];

      if (this.$route.name === 'organisations') {
        crudApi.getOrganisations(cfg.api).then(json => this.tableData = json.data ? json.data : json);
      } else {
        crudApi.getAll(this.entityType, this.$store.state.auth.user.organisation_id).then(json => this.tableData = json.data ? json.data : json);
      }
      return cfg;
    }
  },
  methods: {
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    handleNew() {
      this.$router.push({name:"entity-edit", params:{entityType:this.entityType}});
    },
    handleEdit(index, row) {
      this.$router.push({name:"entity-edit", params:{entity:row, entityType:this.entityType}});
    },
    handleSettings(index, row) {
      this.$router.push({name:"entity-configs", params:{configurationGroup:row}});
    },
    handleMembers(index, row) {
      this.$router.push({name:"entity-members", params:{model:row, entityType:this.entityType, groupId:row.groupId}});
    },
    handleLinks(index, row) {
      this.$router.push({name:"entity-links", params:{model:row, entityType:this.entityType}});
    },
    handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure?',
        text: `Delete : ${row.name}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.name}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      crudApi.delete(this.$route.name, row.id)

      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    dataChanged() {
      console.log("table dataChanged")
      clientPaginationMixin.data()
      clientPaginationMixin.dataChanged()
    }
  }
};
</script>
<style>
.no-border-card .card-footer{
  border-top: 0;
}
</style>
